/**
 * Drive Gatex | Core JavaScript 2026
 * Stack: GSAP, ScrollTrigger, SplitType, Swiper, Lucide
 */

document.addEventListener('DOMContentLoaded', () => {

  // --- 1. FIX: Prevent "No checkout popup config found" errors ---
  window.checkoutConfig = window.checkoutConfig || {};
  window.checkoutPopup = window.checkoutPopup || { config: {} };

  // --- 2. ICON INITIALIZATION ---
  if (typeof lucide !== 'undefined') {
      lucide.createIcons();
  }

  // --- 3. GSAP PLUGINS REGISTRATION ---
  gsap.registerPlugin(ScrollTrigger);

  // --- 4. MOBILE MENU (OVERLAY) ---
  const burger = document.getElementById('burger');
  const mobileMenu = document.getElementById('mobile-menu');
  const menuLinks = document.querySelectorAll('.mobile-menu__link');

  const toggleMenu = () => {
      if (!burger || !mobileMenu) return;
      burger.classList.toggle('burger--active');
      mobileMenu.classList.toggle('mobile-menu--active');
      // Block body scroll when menu is open
      document.body.style.overflow = mobileMenu.classList.contains('mobile-menu--active') ? 'hidden' : '';
  };

  if (burger) burger.addEventListener('click', toggleMenu);

  menuLinks.forEach(link => {
      link.addEventListener('click', () => {
          if (mobileMenu && mobileMenu.classList.contains('mobile-menu--active')) toggleMenu();
      });
  });

  // --- 5. HERO ANIMATION (SplitType + GSAP) ---
  const heroTitle = document.querySelector('.js-hero-title');
  if (heroTitle) {
      const split = new SplitType(heroTitle, { types: 'lines, words' });
      gsap.set(heroTitle, { visibility: 'visible' });

      const tlHero = gsap.timeline({ defaults: { ease: 'power4.out' } });
      tlHero
          .to('.js-hero-badge', { opacity: 1, y: 0, duration: 0.8, delay: 0.2 })
          .from(split.words, {
              opacity: 0,
              y: 50,
              rotateX: -20,
              stagger: 0.05,
              duration: 0.8
          }, '-=0.4')
          .to('.js-hero-subtitle', { opacity: 1, y: 0, duration: 0.8 }, '-=0.6')
          .to('.js-hero-actions', { opacity: 1, y: 0, duration: 0.8 }, '-=0.6');

      // Parallax effect for the background grid
      gsap.to('.hero__abstract', {
          scrollTrigger: {
              trigger: '#hero',
              start: 'top top',
              end: 'bottom top',
              scrub: true
          },
          y: 200,
          rotateX: 75
      });
  }

  // --- 6. ADAPTIVE SWIPER (INNOVATIONS) ---
  let innovationSwiper;

  function handleSwiper() {
      const sliderContainer = document.querySelector('.innovationSwiper');
      if (!sliderContainer) return;

      if (window.innerWidth >= 768) {
          if (!innovationSwiper) {
              innovationSwiper = new Swiper('.innovationSwiper', {
                  slidesPerView: 2,
                  spaceBetween: 20,
                  loop: true,
                  navigation: {
                      nextEl: '.next',
                      prevEl: '.prev',
                  },
              });
          }
      } else {
          if (innovationSwiper) {
              innovationSwiper.destroy(true, true);
              innovationSwiper = undefined;
          }
      }
  }

  handleSwiper();
  window.addEventListener('resize', handleSwiper);

  // --- 7. UNIVERSAL REVEAL ANIMATION ---
  const revealElements = document.querySelectorAll('.js-reveal');
  revealElements.forEach((el) => {
      gsap.from(el, {
          scrollTrigger: {
              trigger: el,
              start: 'top 88%',
              toggleActions: 'play none none none'
          },
          opacity: 0,
          y: 40,
          duration: 1,
          ease: 'power3.out'
      });
  });

  // --- 8. CONTACT FORM + CAPTCHA ---
  const contactForm = document.getElementById('contact-form');
  if (contactForm) {
      const phoneInput = document.getElementById('phone');
      const captchaLabel = document.getElementById('captcha-question');
      const captchaInput = document.getElementById('captcha-answer');

      // Math captcha generation
      let n1 = Math.floor(Math.random() * 10) + 1;
      let n2 = Math.floor(Math.random() * 10) + 1;
      let sum = n1 + n2;
      if (captchaLabel) captchaLabel.innerText = `${n1} + ${n2}`;

      // Phone validation (digits only)
      if (phoneInput) {
          phoneInput.addEventListener('input', (e) => {
              e.target.value = e.target.value.replace(/\D/g, '');
          });
      }

      // Form submission
      contactForm.addEventListener('submit', (e) => {
          e.preventDefault();

          if (parseInt(captchaInput.value) !== sum) {
              alert('Incorrect captcha answer! Please solve the equation.');
              return;
          }

          const btn = contactForm.querySelector('.form__submit');
          const originalBtnText = btn.innerHTML;
          btn.innerHTML = 'Sending data...';
          btn.disabled = true;

          // Simulation of AJAX request
          setTimeout(() => {
              gsap.to(contactForm, {
                  opacity: 0,
                  y: -20,
                  duration: 0.5,
                  onComplete: () => {
                      contactForm.style.display = 'none';
                      const success = document.getElementById('success-message');
                      if (success) {
                          success.style.display = 'flex';
                          gsap.from(success, { opacity: 0, y: 20, duration: 0.5 });
                      }
                  }
              });
          }, 1500);
      });
  }

  // --- 9. COOKIE POPUP ---
  const cookiePopup = document.getElementById('cookie-popup');
  const cookieBtn = document.getElementById('cookie-accept');

  // Updated storage key for the new brand
  if (cookiePopup && !localStorage.getItem('drive_gatex_cookies_accepted')) {
      setTimeout(() => {
          cookiePopup.classList.add('cookie-popup--active');
      }, 3000);
  }

  if (cookieBtn) {
      cookieBtn.addEventListener('click', () => {
          localStorage.setItem('drive_gatex_cookies_accepted', 'true');
          cookiePopup.classList.remove('cookie-popup--active');
      });
  }

  // --- 10. HEADER SCROLL EFFECT ---
  window.addEventListener('scroll', () => {
      const header = document.querySelector('.header');
      if (!header) return;

      if (window.scrollY > 60) {
          header.style.padding = '12px 0';
          header.style.background = 'rgba(10, 10, 10, 0.98)';
          // Blue border for Belgium/Tech theme instead of orange
          header.style.borderBottom = '1px solid rgba(0, 95, 253, 0.4)';
      } else {
          header.style.padding = '20px 0';
          header.style.background = 'rgba(10, 10, 10, 0.8)';
          header.style.borderBottom = '1px solid rgba(0, 95, 253, 0.1)';
      }
  });
});